const setCurrentAddress = (val = null) => {
  return {
    type: 'SET_CURRENTADDRESS',
    data: val,
  }
}
const setCurrentNumber = (val = null) => {
  return {
    type: 'SET_CURRENTNUMBER',
    data: val,
  }
}

const setCurrentVillageName = (val = null) => {
  return {
    type: 'SET_CURRENTVILLAGENAME',
    data: val,
  }
}

const setCurrentVillage = (val = null) => {
  return {
    type: 'SET_CURRENTVILLAGE',
    data: val,
  }
}

const setCurrentFloor = (val = null) => {
  return {
    type: 'SET_CURRENTFLOOR',
    data: val,
  }
}

const setCurrentRoad = (val = null) => {
  return {
    type: 'SET_CURRENTROAD',
    data: val,
  }
}

const setCurrentProvince = (id = null, val = null) => {
  return {
    type: 'SET_CURRENTPROVINCE',
    id,
    data: val,
  }
}

const setCurrentDistrict = (id = null, val = null) => {
  return {
    type: 'SET_CURRENTDISTRICT',
    id,
    data: val,
  }
}

const setCurrentSubDistrict = (id = null, val = null) => {
  return {
    type: 'SET_CURRENTSUBDISTRICT',
    id,
    data: val,
  }
}

const setCurrentZipcode = (val = null) => {
  return {
    type: 'SET_CURRENTZIPCODE',
    data: val,
  }
}

export default {
  setCurrentAddress,
  setCurrentNumber,
  setCurrentVillageName,
  setCurrentVillage,
  setCurrentFloor,
  setCurrentRoad,
  setCurrentProvince,
  setCurrentDistrict,
  setCurrentSubDistrict,
  setCurrentZipcode
}
